import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config/apiBase";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import { FaCalendarAlt } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Transactions.css";

const getStatusClass = (status) => {
  switch (status) {
    case "Completed":
      return "status-completed";
    case "Pending":
      return "status-pending";
    case "On Hold":
      return "status-onhold";
    default:
      return "";
  }
};

const ITEMS_PER_PAGE = 10;

const AdminCourseTransactionPage = () => {
  const [combined, setCombined] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const adminUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (!adminUser?.isAdmin) return;

    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");

        console.log("🔄 Fetching all data...");
        const [txRes, courseRes, progressRes, usersRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/transactions/allTransactions`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${API_BASE_URL}/courses/allCourses`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${API_BASE_URL}/progress/allProgress`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${API_BASE_URL}/users`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        const transactions = txRes.data;
        const courses = courseRes.data;
        const progressRecords = progressRes.data;
        const users = usersRes.data;

        console.log("✅ Transactions:", transactions);
        console.log("✅ Courses:", courses);
        console.log("✅ Progress:", progressRecords);
        console.log("✅ Users:", users);

        const enrichedData = transactions.map((tx) => {
          const user = users.find((u) => u.email === tx.email);
          const course = courses.find((c) => c.wooProductId === tx.Product);

          return {
            fullName: user?.name || "Unknown",
            email: tx.email,
            phone: user?.phone || "—",
            registeredOn: user?.createdAt || tx.date,
            courseTitle: course?.title || "—",
            status: tx.status,
            amount: tx.amount,
          };
        });

        console.log("🧠 Enriched Combined Data:", enrichedData);
        setCombined(enrichedData);
        setFilteredData(enrichedData);
      } catch (err) {
        console.error("❌ Error fetching or mapping data:", err);
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  const handleDateRangeChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    if (start && end) {
      const filtered = combined.filter((item) => {
        const itemDate = new Date(item.registeredOn);
        return itemDate >= start && itemDate <= end;
      });
      setFilteredData(filtered);
      setCurrentPage(1);
    } else {
      setFilteredData(combined);
    }
  };

  const paginatedData = filteredData.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  if (!adminUser?.isAdmin) {
    return <div style={{ padding: 40 }}>Access Denied: Admins only.</div>;
  }

  return (
    <div className="dashboard-wrapper">
      <div className="sidebar-fixed">
        <Sidebar isOpen={isSidebarOpen} />
      </div>

      <div className="dashboard-main">
        <Navbar onToggleSidebar={() => setIsSidebarOpen((prev) => !prev)} />

        <div className="transaction-content">
          <div className="table-container">
            <div className="table-header">
              <h4 className="section-title">
                Student Registration & Course Purchase
              </h4>
              <div className="date-range">
                <FaCalendarAlt />
                <DatePicker
                  selected={startDate}
                  onChange={handleDateRangeChange}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  isClearable
                  placeholderText="Filter by date range"
                  className="date-picker-input"
                />
              </div>
            </div>

            {loading ? (
              <p>Loading data...</p>
            ) : (
              <div className="table-scroll-wrapper">
                <table className="transactions-table">
                  <thead>
                    <tr>
                      <th>Student Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Registered On</th>
                      <th>Course</th>
                      <th>Payment Status</th>
                      <th>Amount Paid</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.map((item, i) => (
                      <tr key={i}>
                        <td>{item.fullName}</td>
                        <td>{item.email}</td>
                        <td>{item.phone}</td>
                        <td>{new Date(item.registeredOn).toLocaleDateString()}</td>
                        <td>{item.courseTitle}</td>
                        <td className={getStatusClass(item.status)}>{item.status}</td>
                        <td>${Number(item.amount || 0).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="pagination">
                  {Array.from({
                    length: Math.ceil(filteredData.length / ITEMS_PER_PAGE),
                  }).map((_, index) => (
                    <button
                      key={index}
                      className={currentPage === index + 1 ? "active" : ""}
                      onClick={() => setCurrentPage(index + 1)}
                    >
                      {index + 1}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminCourseTransactionPage;
